import { render, staticRenderFns } from "./ComissaoSimuladorSalario.vue?vue&type=template&id=78956827"
import script from "./ComissaoSimuladorSalario.vue?vue&type=script&lang=js"
export * from "./ComissaoSimuladorSalario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports